module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-grid-slider-wrap"
  }, [_c('div', {
    ref: "sliderBox",
    staticClass: "slider-box"
  }, [_vm._l((_vm.dataset), function(data, i) {
    return [_c('table', {
      class: _vm.getTableClass(i),
      attrs: {
        "tabelIndex": i
      }
    }, [_c('tbody', _vm._l((data.rows), function(row) {
      return _c('tr', _vm._l((row), function(text) {
        return _c('td', [_c('span', {
          staticClass: "text-inner"
        }, [_vm._v(_vm._s(text))])])
      }))
    }))])]
  })], 2), _vm._v(" "), _vm._m(0, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shadow"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11009580!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/data-grid-slider/index.vue
// module id = 225
// module chunks = 0